import { useState } from 'react';
import { CustomDialog } from '@/components/dialog/v1/CustomDialog';
import { useLinkCategoryContextValueHook } from '@/views/mypage/contexts/LinkCategoryContextProvider';
import { ModuleCard } from '../weget-module-card/ModuleCard';
import { POST_LIST_LAYOUTS, POST_LIST_ORDERS, WegetPostListModuleForm } from './WegetPostListModuleForm';

/**
 * 에디터 목록의 글 목록 모듈 카드
 */
export function WegetPostListModuleItem({ moduleItemIndex, moduleItem, clickLog, onReqDelete, onReqChangeIsHide, onReqUpdateInfo }) {
    const linkCategoryContextValueHook = useLinkCategoryContextValueHook();
    const [editOpen, setEditOpen] = useState(false);

    const config = moduleItem?.postListConfig;
    const category = linkCategoryContextValueHook?.content?.find(r => r.id === moduleItem?.linkCategoryId)?.name;
    const summary = [
        config?.group ? `그룹: ${config.group}` : '전체 이야기',
        POST_LIST_LAYOUTS.find(o => o.value === config?.layout)?.label,
        POST_LIST_ORDERS.find(o => o.value === config?.order)?.label,
        config?.limit && `${config.limit}개씩`,
    ].filter(Boolean).join(' · ');

    const handleSubmit = (body) => {
        onReqUpdateInfo({ id: moduleItem?.id, ...body });
        setEditOpen(false);
    }

    return (
        <>
            <ModuleCard
                id={moduleItem.id}
                index={moduleItemIndex}
                isHide={moduleItem?.isHide}
                badgeIcon='/assets/icons/text_default_mainColor.svg'
                badgeLabel='이야기 목록'
                categoryName={category}
                onEdit={() => setEditOpen(true)}
                onToggleHide={onReqChangeIsHide}
                onDelete={onReqDelete}
            >
                <div className="min-w-0">
                    <p className="truncate text-[15px] font-bold text-gray-900">{moduleItem?.title || <span className="font-normal text-gray-400">제목 없음</span>}</p>
                    <p className="truncate text-[12px] text-gray-500">{summary}</p>
                    <p className="mt-1 text-[12px] font-semibold text-gray-600">이야기 클릭 {clickLog?.totalClickCount || 0}</p>
                </div>
            </ModuleCard>

            {editOpen &&
                <CustomDialog open={editOpen} onClose={() => setEditOpen(false)} maxWidth='sm'>
                    <div className="p-5">
                        <CustomDialog.Header style={{ marginBottom: '20px' }}>
                            <CustomDialog.Header.Fake />
                            <CustomDialog.Header.Title>이야기 목록 모듈</CustomDialog.Header.Title>
                            <CustomDialog.Header.Close onClick={() => setEditOpen(false)} />
                        </CustomDialog.Header>
                        <WegetPostListModuleForm initial={moduleItem} submitLabel="수정" onSubmit={handleSubmit} />
                    </div>
                </CustomDialog>
            }
        </>
    );
}
